module.exports = __webpack_public_path__ + "static/img/X智慧云平台.95dbffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/智能碰撞预警系统/X智慧云平台.png
// module id = eQ9S
// module chunks = 0